import React, { useId } from 'react';

import { Grid, SxProps, Typography } from '@mui/material';

import { useValidation } from 'hooks/useValidation';

interface TabuledGridListProps {
    label: string | React.ReactNode;
    value?: string | number | React.ReactNode | HTMLElement;
}

interface TabuledGridProps {
    list: TabuledGridListProps[];
    leftColumnWidth?: number | string;
    showEmpty?: boolean;
    sx?: SxProps;
}

export function TabuledGrid({ list, leftColumnWidth = 200, showEmpty = true, sx }: TabuledGridProps) {
    const id = useId();
    const { validValue } = useValidation();

    return (
        <Grid container spacing={1} direction="column" sx={{ width: '100%', ...sx }}>
            {list.map(({ label, value }: any) => {
                let content = null;

                if (showEmpty || validValue(value)) {
                    content = (
                        <Grid key={Math.random() + id} sx={{ display: 'flex', width: '100%' }}>
                            <Typography
                                sx={{
                                    minWidth: leftColumnWidth,
                                }}
                            >
                                {label}
                            </Typography>

                            <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{value}</Typography>
                        </Grid>
                    );
                }

                return content;
            })}
        </Grid>
    );
}
